import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doDelete, doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const UploadFileAction = createAsyncThunk("uploadFile",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.fileUpload, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const DeleteFileAction = createAsyncThunk("deleteFile",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doDelete(urls?.fileDelete, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const UploadFileSlice = createSlice({
    name: "uploadFile",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false
    },
    reducers: {
        UploadFileReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [UploadFileAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [UploadFileAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [UploadFileAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const DeleteFileSlice = createSlice({
    name: "deleteFile",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false
    },
    reducers: {
        DeleteFileReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [DeleteFileAction.pending]: (state) =>{
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [DeleteFileAction.fulfilled]: (state, {payload})=> {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [DeleteFileAction.rejected]: (state , {payload}) =>{
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        }
    }
})

export const { UploadFileReset } = UploadFileSlice.actions
export const { DeleteFileReset } = DeleteFileSlice.actions
